import React, { useState } from 'react';
import { SlidersHorizontal, Check, Heart } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export interface FilterState {
  species: string[];
  waterType: string[];
  favoritesOnly: boolean;
}
interface FilterPanelProps {
  filters: FilterState;
  onFilterChange: (filters: FilterState) => void;
}
export function FilterPanel({
  filters,
  onFilterChange
}: FilterPanelProps) {
  const [isOpen, setIsOpen] = useState(false);
  const toggleSpecies = (species: string) => {
    const newSpecies = filters.species.includes(species) ? filters.species.filter(s => s !== species) : [...filters.species, species];
    onFilterChange({
      ...filters,
      species: newSpecies
    });
  };
  const toggleWaterType = (type: string) => {
    const newTypes = filters.waterType.includes(type) ? filters.waterType.filter(t => t !== type) : [...filters.waterType, type];
    onFilterChange({
      ...filters,
      waterType: newTypes
    });
  };
  const activeCount = filters.species.length + filters.waterType.length + (filters.favoritesOnly ? 1 : 0);
  return <div className="absolute top-4 left-4 z-30" data-id="element-49">
      <button onClick={() => setIsOpen(!isOpen)} className="float-card px-4 py-2.5 flex items-center space-x-2 text-[var(--text-primary)] hover:bg-[var(--bg-secondary)] transition-colors" data-id="element-50">
        <SlidersHorizontal className="w-4 h-4" data-id="element-51" />
        <span className="text-sm font-medium" data-id="element-52">Filters</span>
        {activeCount > 0 && <span className="w-5 h-5 rounded-full bg-[var(--accent)] text-white text-xs flex items-center justify-center" data-id="element-53">
            {activeCount}
          </span>}
      </button>

      <AnimatePresence data-id="element-54">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -10
      }} transition={{
        type: 'spring',
        stiffness: 400,
        damping: 30
      }} className="mt-2 w-64 float-card p-4" data-id="element-55">
            {/* Favorites */}
            <button onClick={() => onFilterChange({
          ...filters,
          favoritesOnly: !filters.favoritesOnly
        })} className={`w-full flex items-center justify-between px-3 py-2.5 rounded-xl mb-4 transition-colors ${filters.favoritesOnly ? 'bg-rose-50 dark:bg-rose-500/10 text-rose-600 dark:text-rose-400' : 'bg-[var(--bg-secondary)] text-[var(--text-secondary)]'}`} data-id="element-56">
              <div className="flex items-center space-x-2" data-id="element-57">
                <Heart className={`w-4 h-4 ${filters.favoritesOnly ? 'fill-current' : ''}`} data-id="element-58" />
                <span className="text-sm font-medium" data-id="element-59">Favorites only</span>
              </div>
              {filters.favoritesOnly && <Check className="w-4 h-4" data-id="element-60" />}
            </button>

            {/* Species */}
            <div className="mb-4" data-id="element-61">
              <p className="text-xs font-medium text-[var(--text-muted)] uppercase tracking-wide mb-2" data-id="element-62">
                Species
              </p>
              <div className="flex flex-wrap gap-1.5" data-id="element-63">
                {['Trout', 'Bass', 'Salmon', 'Pike'].map(species => {
              const isActive = filters.species.includes(species);
              return <button key={species} onClick={() => toggleSpecies(species)} className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${isActive ? 'bg-[var(--accent)] text-white' : 'bg-[var(--bg-secondary)] text-[var(--text-secondary)] hover:bg-[var(--accent-light)] hover:text-[var(--accent)]'}`} data-id="element-64">
                      {species}
                    </button>;
            })}
              </div>
            </div>

            {/* Water Type */}
            <div data-id="element-65">
              <p className="text-xs font-medium text-[var(--text-muted)] uppercase tracking-wide mb-2" data-id="element-66">
                Water Type
              </p>
              <div className="flex flex-wrap gap-1.5" data-id="element-67">
                {['Lake', 'River', 'Coast'].map(type => {
              const isActive = filters.waterType.includes(type);
              return <button key={type} onClick={() => toggleWaterType(type)} className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${isActive ? 'bg-[var(--accent)] text-white' : 'bg-[var(--bg-secondary)] text-[var(--text-secondary)] hover:bg-[var(--accent-light)] hover:text-[var(--accent)]'}`} data-id="element-68">
                      {type}
                    </button>;
            })}
              </div>
            </div>

            {/* Reset */}
            {activeCount > 0 && <button onClick={() => onFilterChange({
          species: [],
          waterType: [],
          favoritesOnly: false
        })} className="mt-4 text-xs text-[var(--text-muted)] hover:text-[var(--accent)] transition-colors" data-id="element-69">
                Clear all filters
              </button>}
          </motion.div>}
      </AnimatePresence>
    </div>;
}